export default __webpack_public_path__ + "static/media/flag-uk.12a4094a.svg";